import React, { createRef, useEffect, useRef, useState } from "react";
import { Box, useMediaQuery } from "@mui/material";
import PlanoSelectCard from "./PlanoSelectCard/PlanoSelectCard";
import PlanogramImageCard from "./PlanoSelectCard/PlanogramImageCard";
import PlanogramHome from "./PlanogramHome/PlanogramHome";
import { useDispatch, useSelector } from "react-redux";
import { getData } from "../../Hooks/apiCalls";
import { toast } from "react-toastify";
import { PlanoLoaderModal } from "../../Common";
import { setBayDetails } from "../../Store/Plano/planoStore";
import PlanogramImageCard2 from "./PlanoSelectCard/PlanogramImageCard2";
import { isDevelopment } from "../../Hooks/constants";
import { openSideBarModal, setTokenErr } from "../../Store/Common/commonStore";
const Planogram = () => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm")); // Adjust breakpoint as needed
  const [screen, setScreen] = useState("");
  const ref = useRef(null);
  const [selectData, setSelectData] = useState("");
  const [loader, setLoader] = useState(false);
  const [visualisationData, setVisualisationData] = useState([]);
  const [selectedVisualizationData, setSelecteVisualizationData] = useState([]);
  const token = useSelector((state) => state.common.token);
  const locations = useSelector((state) => state.common.loc);

  const functionSetSelectedVisualisationData = (data) => {
    setSelecteVisualizationData(data);
  };
  const getlocplanologgerversions = async () => {
    setLoader(true);
    const { data } = await getData(
      `${
        isDevelopment
          ? process.env.REACT_APP_APIKEY_DEV
          : process.env.REACT_APP_APIKEY_PROD
      }getlocplanologgerversions?loc=${locations}`,
      true
    );
    if (data.status === "success") {
      setVisualisationData(data.data);
      setLoader(false);
    } else {
      toast.error(data.message);
      setLoader(false);
      dispatch(setTokenErr(true));
    }
  };

  const [depData, setDepData] = useState();
  const getdeptdetails = async (date) => {
    setLoader(true);
    const { data } = await getData(
      `${
        isDevelopment
          ? process.env.REACT_APP_APIKEY_DEV
          : process.env.REACT_APP_APIKEY_PROD
      }getdeptdetails?loc=${locations}&version_date=${date.toString()}`,
      true
    );

    if (data.status === "success") {
      setDepData(data.data);
      setLoader(false);
    } else {
      toast.error(data.message);
      setLoader(false);
    }
  };
  const [selectedBay, setSelectedBay] = useState("");
  const handleChangeForBay = (e) => {
    setSelectedBay(e.target.value);
  };

  const [planoImageSrc, setPlanoImageSrc] = useState([]);
  const [imageData, setImageData] = useState(false);
  const bayCheck = useSelector((state) => state.plano.bayDetails);

  const dispatch = useDispatch();
  const getplanogramImage = async (date) => {
    setLoader(true);
    setPlanoImageSrc("");
    setImageData(false);
    const { data } = await getData(
      `${
        isDevelopment
          ? process.env.REACT_APP_APIKEY_DEV
          : process.env.REACT_APP_APIKEY_PROD
      }getplanogram?loc=${locations}&bay_number=${selectedBay}&department=${encodeURIComponent(
        selectData
      )}`,
      true
    );

    if (data.status === "success") {
      setPlanoImageSrc(data.data);
      setImageData(true);
      const newData = [...bayCheck, { [selectedBay]: data.data }];
      dispatch(setBayDetails(newData));
      setLoader(false);
    } else {
      toast.error(data.message);
      setLoader(false);
      setImageData(false);
    }
  };
  const [bayItemsData, setBayItemsData] = useState([]);
  const getbayitems = async (date) => {
    setBayItemsData([]);

    if (selectedBay !== "") {
      const { data } = await getData(
        `${
          isDevelopment
            ? process.env.REACT_APP_APIKEY_DEV
            : process.env.REACT_APP_APIKEY_PROD
        }getbayitems?loc=${locations}&bay_number=${selectedBay}&department=${encodeURIComponent(
          selectData
        )}`,
        true
      );
      if (data.status === "success") {
        setBayItemsData(data.data);
      } else {
        toast.error(data.message);
      }
    }
  };

  useEffect(() => {
    getlocplanologgerversions();
  }, []);

  useEffect(() => {
    dispatch(openSideBarModal(false));
    setPlanoImageSrc([]);
    if (selectedBay !== "") {
      bayCheck?.map((elem, index) => {
        if (Object.keys(elem)[0] === selectedBay) {
          setPlanoImageSrc(Object.values(elem)[0]);
          getbayitems();
          return;
        }
      });
    }
  }, [selectData, selectedBay]);
  return (
    <>
      {screen === "" ? (
        <Box p={5} bgcolor={"whitesmoke"} pl={5} pr={5}>
          <PlanogramHome
            screen={screen}
            setScreen={setScreen}
            visualisationData={visualisationData}
            functionSetSelectedVisualisationData={
              functionSetSelectedVisualisationData
            }
          />
        </Box>
      ) : (
        <Box
          bgcolor={"whitesmoke"}
          pl={5}
          pr={5}
          p={2}
          display={!isSmallScreen && "flex"}
          gap={4}
          mt={4}>
          <PlanoSelectCard
            screen={screen}
            setScreen={setScreen}
            selectData={selectData}
            setSelectData={setSelectData}
            selectedVisualizationData={selectedVisualizationData}
            getdeptdetails={getdeptdetails}
            departmentData={depData}
            selectedBay={selectedBay}
            handleChangeForBay={handleChangeForBay}
            generateImageFunction={getplanogramImage}
            getbayitems={getbayitems}
            bayItemsData={bayItemsData}
            imageSource={planoImageSrc}
            setSelectedBay={setSelectedBay}
          />
          <PlanogramImageCard2
            showImages={selectData}
            source={planoImageSrc}
            bayNumber={selectedBay}
            imageData={imageData}
            ref={ref}
          />
        </Box>
      )}

      <PlanoLoaderModal open={loader} setOpen={setLoader} />
    </>
  );
};

export default Planogram;
